import * as React from 'react';
import { BaseComponent } from './BaseComponent';
import { MessageBoxPayload, ViewSettingsStore } from '../stores/ViewSettingsStore';
import { ViewSettingsActions } from '../actions/ViewSettingsActions';

interface MessageBoxState {
    payload: MessageBoxPayload | null;
}

/**
 * Use <div className="dialog-page-resizer" onClick={UIHelper.stopEvent}>..your elements (labels/buttons)..</div> if you use wrap: true
 */
export class MessageBox extends BaseComponent<{}, MessageBoxState> {
    public componentWillMount(): void {
        this.addStoreListener(ViewSettingsStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element | null {
        if (this.state.payload != null) {
            if (this.state.payload.wrap === false) {
                return this.state.payload.element;
            }

            return (
                <div className="dialog-page" onClick={ViewSettingsActions.closeMessage}>
                    {this.state.payload.element}
                </div>
            );
        }
        return null;
    }

    protected onChange = (): void => {
        this.setState({
            payload: ViewSettingsStore.getState().messagePayload
        });
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MessageBox.tsx